import { render, staticRenderFns } from "./integrallist.vue?vue&type=template&id=2943c68f&scoped=true"
import script from "./integrallist.vue?vue&type=script&lang=js"
export * from "./integrallist.vue?vue&type=script&lang=js"
import style0 from "./integrallist.vue?vue&type=style&index=0&id=2943c68f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943c68f",
  null
  
)

export default component.exports